module.exports = __webpack_public_path__ + "static/media/shape1_2.eecc76d2.obj";